var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11279 22.1609C1.11279 20.0678 2.8096 18.371 4.90272 18.371C6.99584 18.371 8.69264 20.0678 8.69264 22.1609V25.1929C8.69264 27.286 6.99584 28.9828 4.90272 28.9828C2.8096 28.9828 1.11279 27.286 1.11279 25.1929V22.1609Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8204 22.1609C20.8204 20.0678 22.5172 18.371 24.6103 18.371C26.7034 18.371 28.4003 20.0678 28.4003 22.1609V25.1929C28.4003 27.286 26.7034 28.9828 24.6103 28.9828C22.5172 28.9828 20.8204 27.286 20.8204 25.1929V22.1609Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4003 24.4349V15.339C28.4003 7.80382 22.2917 1.69531 14.7565 1.69531C7.2213 1.69531 1.11279 7.80382 1.11279 15.339V24.4349M4.90272 28.9828C2.8096 28.9828 1.11279 27.286 1.11279 25.1929V22.1609C1.11279 20.0678 2.8096 18.371 4.90272 18.371C6.99584 18.371 8.69264 20.0678 8.69264 22.1609V25.1929C8.69264 27.286 6.99584 28.9828 4.90272 28.9828ZM24.6103 28.9828C22.5172 28.9828 20.8204 27.286 20.8204 25.1929V22.1609C20.8204 20.0678 22.5172 18.371 24.6103 18.371C26.7034 18.371 28.4003 20.0678 28.4003 22.1609V25.1929C28.4003 27.286 26.7034 28.9828 24.6103 28.9828Z",
    stroke: "currentColor",
    strokeWidth: 2.183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadphones);
export default __webpack_public_path__ + "static/media/icon_headphones.abe57058.svg";
export { ForwardRef as ReactComponent };